import { createEmotionCache } from '@inflearn/ds-react';

import { createEmotionCache as createEmotionCacheNext } from '@inflearn/ds-react-next';

export const styleCache = createEmotionCache({ key: 'mantine', prepend: true });

export const styleCacheNext = createEmotionCacheNext({
  key: 'mantine-next',
});
